import anime from 'animejs';
import { lerp } from '@/scripts/utils';

const parallax = (el, scroll) => {
  const delta = el.offset < 0 ? -1 : 1;

  let final = 149 * delta;


  if (!el.visible) {
    el.visible = true;

    anime({
      targets: el.node,
      duration: 650,
      opacity: [0, 1],
      easing: 'easeInOutSine',
      delay: 100,
    });
  }

  final = lerp(final, (150 * delta) - ((scroll - el.fromTop) * el.offset), 1);
  el.node.style.transform = `translateY(${final}px)`;
};

export default parallax;
